/**
 * Sentry DSN.
 *
 * Leave empty to disable Sentry.
 */
export const SENTRY_DSN = 'https://74245313f86c1ebe3683306585762fad@sentry.naukosfera.com/4'

/**
 * Release version of Sentry.
 */
export const SENTRY_RELEASE = 'ae7dbc70e3b4ca31049bc2dbb8621171443c379a'
